import { render, staticRenderFns } from "./Finalizacao.vue?vue&type=template&id=31e1453c"
import script from "./Finalizacao.vue?vue&type=script&lang=js"
export * from "./Finalizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports